import React, { useState, useEffect } from "react"; 
import api from "../../Services/api";
import PageDescriptionFootnote from "../Footnote";

const PageDescriptionPlano = (props: any) => {

    const [page, setLayoutPagina] = useState<any[]>([]); 

    useEffect(() => {
        api
        .get("/ObterLayoutPaginaFiltro?Identificador="+props.page)

            .then((response) => {
                 
                setLayoutPagina(response.data.results);
            })
            .catch((err) => {
                
                throw new Error(err);
            });
    }, [props.page]);

    var F = document.querySelector("#politica");
    var A = document.querySelector("#plano");
    var B = document.querySelector("#docs");
    var T = document.querySelector("#indicadores");

    function renderObjectBody(data: any) {
        return { __html: data }
    }
    return (

        <section className="page-description pt-10">
            <div className="container">
                <div className="row justify-content-center">
                    
                    {page?.filter(i => i.Identificador === props.page).map(item => (

                    <div className="col-lg-10">
                       
                        <div className="page-description__desc mb-7 mb-lg-9">
                            <p>
                                 
                                <span dangerouslySetInnerHTML={renderObjectBody(item?.Descricao_x0020_Subtitulo)} />
                            </p>
                        
                            <br/>

                            <button onClick={() =>F?.scrollIntoView()} className="btn btn-primary rounded py-1 px-5 mr-3 mb-3"> Política </button>
							<button onClick={() =>A?.scrollIntoView()} className="btn btn-primary rounded py-1 px-5 mr-3 mb-3"> Plano </button>
							<button onClick={() =>B?.scrollIntoView()} className="btn btn-primary rounded py-1 px-5 mr-3 mb-3"> Documentos </button>
                            <button onClick={() =>T?.scrollIntoView()} className="btn btn-primary rounded py-1 px-5 mr-3 mb-3"> Indicadores </button>

                            </div>
                        <div className="page-description__midias">
                            <PageDescriptionFootnote/>
                        </div>

                    </div>

                    ))}{ page == null &&
                        <div className="col-lg-10">                    
                        <div className="page-description__desc mb-7 mb-lg-9">
                             
							<button onClick={() =>F?.scrollIntoView()} className="btn btn-primary rounded py-1 px-5 mr-3 mb-3"> Política </button>
							<button onClick={() =>A?.scrollIntoView()} className="btn btn-primary rounded py-1 px-5 mr-3 mb-3"> Plano </button>
							<button onClick={() =>B?.scrollIntoView()} className="btn btn-primary rounded py-1 px-5 mr-3 mb-3"> Documentos </button>
                            <button onClick={() =>T?.scrollIntoView()} className="btn btn-primary rounded py-1 px-5 mr-3 mb-3"> Indicadores </button>
                            </div> 
                        <div className="page-description__midias">
                            <PageDescriptionFootnote/>
                        </div>

                    </div>

                    }
                </div>
            </div>
        </section>

    )
};
export default PageDescriptionPlano;
